export const GET_PUBLIC_VIEW_POST_DATA_REQUEST = 'GET_PUBLIC_VIEW_POST_DATA_REQUEST';
export const GET_PUBLIC_VIEW_POST_DATA_SUCCESS = 'GET_PUBLIC_VIEW_POST_DATA_SUCCESS';
export const GET_PUBLIC_VIEW_POST_DATA_FAILURE = 'GET_PUBLIC_VIEW_POST_DATA_FAILURE';

export const RESET_PUBLIC_VIEW_DATA = 'RESET_PUBLIC_VIEW_DATA';

export const GET_PUBLIC_SHARED_POST_DETAILS_REQUEST = 'GET_PUBLIC_SHARED_POST_DETAILS_REQUEST';
export const GET_PUBLIC_SHARED_POST_DETAILS_SUCCESS = 'GET_PUBLIC_SHARED_POST_DETAILS_SUCCESS';
export const GET_PUBLIC_SHARED_POST_DETAILS_FAILURE = 'GET_PUBLIC_SHARED_POST_DETAILS_FAILURE';
export const RESET_PUBLIC_SHARED_POST_DETAILS = 'RESET_PUBLIC_SHARED_POST_DETAILS';